<template>
  <div class="correction">
   <FilesForm />
  </div>
</template>
<script>
import FilesForm from './Files/FilesForm.vue';
export default {
  components: {
    FilesForm,
  },
};
</script>
<style scoped>
.correction{
  overflow: auto;
    height: calc(100% - 128px);
    width: 100%;
  padding: 62px 38px 38px 38px;
}
@media screen and (min-width: 394px) {
  .correction{
    overflow: auto;
    height: calc(100% - 93px);
  }
}
</style>
